import React from "react";
import "../../styles/EmptyItemsPlaceholder.css";
import {Button} from "@vitalsource/vstui";
import styled from "styled-components";
import Svg from "react-inlinesvg";
import emptyStateDeskSvg from "../../img/EmptyStateDesk.svg";

const CustomButton = styled(Button) `
  position: relative;
  padding: 8px;
  width: 128px;
  height: 40px;
  font-weight: 700;
  min-height: 40px;
  font-size: 16px;
  > div {
    min-height: 0px;
    height: 100%;
  }
  margin: 16px auto 16px auto;
`;

export interface EmptyItemsPlaceholderProps  {
  buttonOnClick: (e: MouseEvent) => void;
}

const EmptyItemsPlaceholder = (props: EmptyItemsPlaceholderProps) => {
  return (
      <div className={"emptystate-container"}>
        <div className={"message"}>
          <div className={"message__header"}>Nothing here</div>
          <div className={"message__description"}>Add your first EPUB now.</div>
          <CustomButton className={"add_button"}
                  fullWidth size="large"
                  onClick={props.buttonOnClick}>Add</CustomButton>
        </div>
        <div className="desk__animation_group">
          <div className="desk__line"/>
          <img className="desk__svg" src={emptyStateDeskSvg} alt={"Desk with paper and pencils"} title={"Desk with paper and pencils"}/>
          <div className="desk__ball_shadow"/>
          <div className="desk__ball"/>
        </div>
      </div>)
};

export default EmptyItemsPlaceholder;
